import React from 'react';

export interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  viewBox?: string;
}

export interface IconComponentProps extends IconProps {
  children: React.ReactNode;
}

const Icon: React.FC<IconComponentProps> = ({
  size = 24,
  color = '#343B91',
  className = '',
  style = {},
  viewBox = '0 0 24 24',
  children,
}) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        color,
        ...style,
      }}
    >
      {children}
    </svg>
  );
};

export default Icon;

